import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import { DataPropertyProfileState } from "./model";

let state: DataPropertyProfileState = {
  dataPropertyProfiles: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<DataPropertyProfileState, RootStateType>;
